module.exports = __webpack_public_path__ + "static/media/delta_heatmap_2.dcf1ef77.png";